import React from 'react'

class Vspacer extends React.Component {
    constructor(props) {
        super(props)
        const hasBorder = props.border === "true" ? true : false
        this.state = {
            hasBorder: hasBorder
        }
    }

    render() {
        return (
            <div className={`vspacer ${this.state.hasBorder ? "vspacer-border" : ""}`} ></div>
        )
    }
}

export default Vspacer
